import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title-inner log-action" }
const _hoisted_2 = { class: "title-inner-left" }
const _hoisted_3 = ["value", "options"]
const _hoisted_4 = { class: "container-filter-panel" }
const _hoisted_5 = { class: "filter-search" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "text-center p-10"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center p-10"
}
const _hoisted_9 = {
  key: 2,
  class: "container-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["value", "checked", "onCheckboxChange"]
const _hoisted_12 = {
  key: 0,
  class: "badge badge-sm bg-warning"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-sm bg-info"
}
const _hoisted_14 = { class: "filter-section" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "filter-section" }
const _hoisted_17 = ["value", "disabled"]
const _hoisted_18 = { class: "filter-section" }
const _hoisted_19 = ["value", "disabled"]
const _hoisted_20 = { class: "filter-footer" }
const _hoisted_21 = { class: "filter-instruction" }
const _hoisted_22 = { class: "mt-10" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "title-inner-right" }
const _hoisted_27 = {
  class: "status log-action text-center p-10",
  style: {"min-width":"80px"}
}
const _hoisted_28 = { class: "log-action ml-5" }
const _hoisted_29 = { class: "filter-popup" }
const _hoisted_30 = ["value", "checked"]
const _hoisted_31 = { class: "log-action ml-5" }
const _hoisted_32 = ["value", "placeholder"]
const _hoisted_33 = {
  class: "fixed",
  cellpadding: "0",
  cellspacing: "0"
}
const _hoisted_34 = { class: "logs-body" }
const _hoisted_35 = { class: "time" }
const _hoisted_36 = { class: "msg" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  colspan: "2",
  class: "msg text-muted"
}
const _hoisted_39 = {
  key: 0,
  class: "filter-indicator"
}
const _hoisted_40 = { key: 2 }
const _hoisted_41 = {
  colspan: "2",
  class: "msg text-muted"
}

import { useStore } from 'vuex';
import {
  ref,
  onMounted,
  onBeforeUnmount,
  computed,
  nextTick,
  PropType,
} from 'vue';

import Socket, {
  EVENT_CONNECTED,
  EVENT_DISCONNECTED,
  EVENT_MESSAGE,
  EVENT_CONNECT_ERROR
} from '@shell/utils/socket';
import day from 'dayjs';
import AnsiUp from 'ansi_up';
import { addParams } from '@shell/utils/url';
import { downloadFile } from '@shell/utils/download';
import { escapeHtml, escapeRegex } from '@shell/utils/string';
import { LOGS_TIME, LOGS_WRAP, DATE_FORMAT, TIME_FORMAT } from '@shell/store/prefs';

import Window from '@shell/components/nav/WindowManager/Window';

import { useApplicationSocketMixin } from './ApplicationSocketMixin';

interface ContainerInfo {
  name: string;
  podName: string;
  isInitContainer: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationLogs',
  props: {
  application: {
    type: Object as PropType<object>,
    default: null,
  },
  endpoint: {
    type: String as PropType<string>,
    default: '',
  },
  ansiToHtml: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  initialInstance: {
    type:    String,
    default: null,
  },
},
  setup(__props) {

const store = useStore();
const t = store.getters['i18n/t'];

const props = __props;

const {
  socket,
  isOpen,
  backlog,
  instanceChoices,
  getRootSocketUrl,
} = useApplicationSocketMixin(props);

const lastId = ref<number>(1);
const search = ref<string>('');
const instance = ref<string>(props.initialInstance || instanceChoices[0]);
const lines = ref<Array<any>>([]);
const timerFlush = ref<object>(null);
const isFollowing = ref<boolean>(false);
const active = ref<boolean>(true);
const body = ref<HTMLElement>(null);
const isApplyingFilters = ref<boolean>(false);

// Time-based filter parameters
const tail = ref<number | null>(null); // Number of lines to show
const since = ref<string | null>(null); // Duration like "1h", "30m", "24h"
const sinceTime = ref<string | null>(null); // ISO datetime string from native input

// Container filtering state
const availableContainers = ref<ContainerInfo[]>([]);
const selectedContainers = ref<Set<string>>(new Set());
const excludedContainers = ref<Set<string>>(new Set());
const filterMode = ref<'include' | 'exclude'>('exclude');
const containerSearch = ref<string>('');
const loadingContainers = ref<boolean>(false);

const ansiup = new AnsiUp();
const timestamps = store.getters['prefs/get'](LOGS_TIME);
const wrap = ref<boolean>(store.getters['prefs/get'](LOGS_WRAP));

onMounted(async () => {
  await fetchContainers();
  await connect();
  let boundUpdateFollowing = updateFollowing.bind(body);
  body.value.addEventListener('scroll', boundUpdateFollowing);
  timerFlush.value = setInterval(flush, 100);
});

onBeforeUnmount(() => {
  const el = document.querySelector('.logs-container') as HTMLElement;
  if (el) {
    el.removeEventListener('scroll', updateFollowing);
  }
  cleanup();
  isOpen.value = false;
});

const instanceChoicesWithNone = computed(() => {
  return [
    ...instanceChoices.value.map((choice) => ({
      label: choice,
      value: choice,
    })),
    {
      label: 'No Instance Filter',
      value: null
    }
  ];
});

// Compute active filter count
const activeFilterCount = computed(() => {
  if (filterMode.value === 'include') {
    return selectedContainers.value.size;
  } else {
    return excludedContainers.value.size;
  }
});

// Filter containers for the search
const filteredContainers = computed(() => {
  if (!containerSearch.value) {
    return availableContainers.value;
  }
  const searchLower = containerSearch.value.toLowerCase();
  return availableContainers.value.filter(c =>
    c.name.toLowerCase().includes(searchLower) ||
    c.podName.toLowerCase().includes(searchLower)
  );
});

const filtered = computed(() => {
  let filteredLines = lines.value;

  // Filter out excluded containers from existing logs
  if (excludedContainers.value.size > 0) {
    filteredLines = filteredLines.filter(line => {
      // Extract container name from log line format: [PodName] ContainerName Message
      const match = line.rawMsg.match(/\[[^\]]+\]\s+(\S+)\s+/);
      if (match && match[1]) {
        const containerName = match[1];
        return !excludedContainers.value.has(containerName);
      }
      return true; // Keep line if we can't parse container name
    });
  }

  if (!search.value && !instance.value) {
    return filteredLines;
  }

  const re = new RegExp(escapeRegex(search.value), 'img');
  const out = [];

  for (const line of filteredLines) {
    let msg = line.rawMsg;

    if (instance.value) {
      const pod = msg.substring(1, msg.length);

      if (!pod.startsWith(instance.value)) {
        continue;
      }
    }

    const matches = msg.match(re);

    if (!matches) {
      continue;
    }

    const parts = msg.split(re);

    msg = '';
    while (parts.length || matches.length) {
      if (parts.length) {
        msg += ansiup.ansi_to_html(parts.shift()); // This also escapes
      }

      if (matches.length) {
        msg += `<span class="highlight">${ ansiup.ansi_to_html(matches.shift()) }</span>`;
      }
    }

    out.push({
      id:   line.id,
      time: line.time,
      msg,
    });
  }

  return out;
});

const timeFormatStr = computed(() => {
  const dateFormat = escapeHtml(store.getters['prefs/get'](DATE_FORMAT));
  const timeFormat = escapeHtml(store.getters['prefs/get'](TIME_FORMAT));

  return `${ dateFormat } ${ timeFormat }`;
});

const getSocketUrl = async () => {
  const { url, token } = await getRootSocketUrl();

  // Build params object with time-based filters
  const params: any = {
    follow: true,
    authtoken: token
  };

  // Add optional time-based filter parameters if they have values
  if (tail.value !== null && tail.value > 0) {
    params.tail = tail.value;
  }

  // Add time-based filters (since_seconds or since duration)
  if (sinceTime.value) {
    const selectedTime = new Date(sinceTime.value).getTime();
    const secondsAgo = Math.floor((Date.now() - selectedTime) / 1000);

    if (secondsAgo > 0) {
      params.since_seconds = secondsAgo;
    }
  } else if (since.value) {
    params.since = since.value; // Duration like "1h", "30m", "24h"
  }

  // Add container filter parameters
  if (filterMode.value === 'include' && selectedContainers.value.size > 0) {
    params.include_containers = Array.from(selectedContainers.value).join(',');
  }

  if (excludedContainers.value.size > 0) {
    params.exclude_containers = Array.from(excludedContainers.value).join(',');
  }

  return addParams(url, params);
};

const connect = async () => {
  console.log('Connecting to application logs socket...');
  // Disconnect existing socket and clear logs
  if (socket.value) {
    console.log('Disconnecting existing socket...');
    await socket.value.disconnect();
    socket.value = null;
  }
  backlog.value = [];
  lines.value = [];

  const url = await getSocketUrl();

  socket.value = new Socket(url, true, 600000);
  socket.value.setAutoReconnectUrl(getSocketUrl);

  socket.value.addEventListener(EVENT_CONNECTED, () => {
    lines.value = [];
    backlog.value = [];
    isOpen.value = true;
  });

  socket.value.addEventListener(EVENT_DISCONNECTED, () => {
    isOpen.value = false;
  });

  socket.value.addEventListener(EVENT_CONNECT_ERROR, (e: any) => {
    isOpen.value = false;
    console.error('WebSocket Connect Error', e);
  });

  socket.value.addEventListener(EVENT_MESSAGE, async (e: any) => {
    let parsedData;

    try {
      parsedData = JSON.parse(e.detail.data);
    } catch (e) {
      console.warn('Unable to parse websocket data: ', e);
      return;
    }

    const { PodName, ContainerName, Message, Timestamp } = parsedData;

    // Filter out excluded containers client-side as a safety measure
    if (ContainerName && excludedContainers.value.has(ContainerName)) {
      return; // Skip this log if container is excluded
    }

    // Extract container name from log data if not already discovered
    // This is especially important for staging logs where pods API may not be available
    if (ContainerName) {
      const existingContainer = availableContainers.value.find(c => c.name === ContainerName);
      if (!existingContainer) {
        availableContainers.value.push({
          name: ContainerName,
          podName: PodName || '',
          isInitContainer: false, // We can't determine this from log data
        });
        // If we were loading containers, mark as complete once we find at least one
        if (loadingContainers.value && availableContainers.value.length > 0) {
          loadingContainers.value = false;
        }
      }
    }

    const line = `[${ PodName }] ${ ContainerName } ${ Message }`;

    if (line == "[]  ___FILTER_START___") {
      // Clear existing logs before new filtered logs arrive
      lines.value = [];
      backlog.value = [];
      return;
    }

    if (line == "[]  ___FILTER_COMPLETE___") {
      isApplyingFilters.value = false;
      return;
    }

    backlog.value.push({
      id:     lastId.value++,
      msg:    props.ansiToHtml ? ansiup.ansi_to_html(line) : line,
      rawMsg: line,
      time:   Timestamp || null,
    });
  });

  socket.value.connect();
};

const flush = () => {
  if (backlog.value.length) {
    lines.value.push(...backlog.value);
    backlog.value = [];
  }

  if (isFollowing.value) {
    nextTick(() => {
      follow();
    });
  }
};

const updateFollowing = () => {
  const el = body.value;

  isFollowing.value = el.scrollTop + el.clientHeight + 2 >= el.scrollHeight;
};

const clear = () => {
  lines.value = [];
};

const download = () => {
  const date = new Date().toISOString().split('.')[0];
  const fileName = `${ props.application.nameDisplay }-${ date }`;

  downloadFile(fileName, lines.value.map((l) => `${ l.rawMsg }`).join('\n'));
};

const follow = () => {
  body.value.scrollTop = body.value.scrollHeight;
};

const toggleWrap = () => {
  store.dispatch('prefs/set', { key: LOGS_WRAP, value: wrap.value });
};

const format = (time) => {
  if (!time) {
    return '';
  }

  return day(time).format(timeFormatStr.value);
};

const cleanup = () => {
  if (socket.value) {
    socket.value.disconnect();
    socket.value = null;
  }

  clearInterval(timerFlush.value);
};

const clearFilters = () => {
  tail.value = null;
  since.value = null;
  sinceTime.value = null;
  applyFilters();
};

const applyFilters = async () => {
  // Prevent multiple simultaneous reconnections
  if (isApplyingFilters.value) {
    return;
  }

  isApplyingFilters.value = true;

  // Clear existing lines before applying new filters to prevent duplicates
  lines.value = [];
  backlog.value = [];

  try {
    // Clear conflicting filters
    if (sinceTime.value && since.value) {
      sinceTime.value = undefined;
    }

    let sinceTimeParsed = undefined;
    if (sinceTime.value) {
      sinceTimeParsed = new Date(sinceTime.value).toISOString();
    }

    // Build filter params including container filters
    // If no filters are active, resume following mode
    // If filters are active, use one-shot mode (follow: false)
    const hasTimeFilters = tail.value != null || since.value != null || sinceTime.value != null;
    const hasContainerFilters = (filterMode.value === 'include' && selectedContainers.value.size > 0) || excludedContainers.value.size > 0;

    const filterParams: any = {
      follow: !hasTimeFilters && !hasContainerFilters, // Follow only when no filters
      tail: tail.value != null ? tail.value : (!hasTimeFilters && !hasContainerFilters ? 10000 : null),
      since: since.value,
      since_time: sinceTimeParsed,
    };

    // Add container filter parameters
    if (filterMode.value === 'include' && selectedContainers.value.size > 0) {
      filterParams.include_containers = Array.from(selectedContainers.value).join(',');
    }

    if (excludedContainers.value.size > 0) {
      filterParams.exclude_containers = Array.from(excludedContainers.value).join(',');
    }

    const payload = {
      type: 'filter_params',
      params: filterParams
    };

    const payload_string = JSON.stringify(payload);

    socket.value.send(payload_string);

    // Safety timeout: reset flag after 5 seconds even if marker not received
    setTimeout(() => {
      if (isApplyingFilters.value) {
        console.warn('Filter complete marker not received, resetting flag');
        isApplyingFilters.value = false;
      }
    }, 5000);

  } catch (e) {
    console.error('Error applying log filters:', e);
    isApplyingFilters.value = false;
  }
};

// Container filtering functions
const fetchContainers = async () => {
  loadingContainers.value = true;
  try {
    const namespace = props.application?.meta?.namespace;
    const appName = props.application?.meta?.name;

    if (!namespace || !appName) {
      console.warn('Missing namespace or app name for container fetch');
      return;
    }

    const res = await store.dispatch('epinio/request', {
      url: `/api/v1/namespaces/${ namespace }/applications/${ appName }/pods`
    });

    const containers: ContainerInfo[] = [];

    if (res && res.data) {
      for (const pod of res.data) {
        const podName = pod.name;

        // Add main containers
        if (pod.containers) {
          for (const container of pod.containers) {
            containers.push({
              name: container.name,
              podName,
              isInitContainer: false,
            });
          }
        }

        // Add init containers
        if (pod.init_containers) {
          for (const container of pod.init_containers) {
            containers.push({
              name: container.name,
              podName,
              isInitContainer: true,
            });
          }
        }
      }
    }

    availableContainers.value = containers;
  } catch (e) {
    console.error('Error fetching containers:', e);
  } finally {
    loadingContainers.value = false;
  }
};

const isSidecar = (containerName: string): boolean => {
  const sidecarPrefixes = ['linkerd-', 'istio-'];
  return sidecarPrefixes.some(prefix => containerName.startsWith(prefix));
};

const toggleContainer = (containerName: string) => {
  if (filterMode.value === 'include') {
    if (selectedContainers.value.has(containerName)) {
      selectedContainers.value.delete(containerName);
    } else {
      selectedContainers.value.add(containerName);
    }
    selectedContainers.value = new Set(selectedContainers.value);
  } else {
    if (excludedContainers.value.has(containerName)) {
      excludedContainers.value.delete(containerName);
    } else {
      excludedContainers.value.add(containerName);
    }
    excludedContainers.value = new Set(excludedContainers.value);
  }
};

const isContainerSelected = (containerName: string): boolean => {
  if (filterMode.value === 'include') {
    return selectedContainers.value.has(containerName);
  } else {
    return excludedContainers.value.has(containerName);
  }
};

const clearContainerFilters = () => {
  selectedContainers.value.clear();
  excludedContainers.value.clear();
  selectedContainers.value = new Set();
  excludedContainers.value = new Set();
};

return (_ctx: any,_cache: any) => {
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_openBlock(), _createBlock(_unref(Window), {
    active: active.value,
    "before-close": cleanup,
    class: "epinio-app-log"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(instanceChoices).length > 1)
            ? (_openBlock(), _createElementBlock("trailhand-dropdown", {
                key: 0,
                value: instance.value,
                options: instanceChoicesWithNone.value,
                size: "small",
                placeholder: "Filter by Instance",
                position: "top",
                onDropdownChange: _cache[0] || (_cache[0] = (e) => instance.value = e.detail.value )
              }, null, 40, _hoisted_3))
            : _createCommentVNode("", true),
          _cache[23] || (_cache[23] = _createTextVNode()),
          _createVNode(_component_VDropdown, {
            placement: "bottom-start",
            distance: 6
          }, {
            popper: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("trailhand-text-input", {
                    value: containerSearch.value,
                    style: {"width":"100%"},
                    size: "small",
                    type: "text",
                    placeholder: "Search containers...",
                    onTextInputChange: _cache[1] || (_cache[1] = ($event: any) => (containerSearch.value = $event.detail.value))
                  }, null, 40, _hoisted_6)
                ]),
                _cache[16] || (_cache[16] = _createTextVNode()),
                (loadingContainers.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "\n                  Loading containers...\n                "))
                  : (filteredContainers.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "\n                  No containers found\n                "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredContainers.value, (container) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${container.podName}-${container.name}`,
                            class: _normalizeClass(["container-item", {
                      'is-selected': isContainerSelected(container.name),
                      'is-sidecar': isSidecar(container.name)
                    }]),
                            onClick: ($event: any) => (toggleContainer(container.name))
                          }, [
                            _createElementVNode("trailhand-checkbox", {
                              value: container.name,
                              checked: isContainerSelected(container.name),
                              onCheckboxChange: ($event: any) => (toggleContainer(container.name))
                            }, _toDisplayString(container.name), 41, _hoisted_11),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            (isSidecar(container.name))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "\n                      Sidecar\n                    "))
                              : _createCommentVNode("", true),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            (container.isInitContainer)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "\n                      Init\n                    "))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_10))
                        }), 128))
                      ])),
                _cache[17] || (_cache[17] = _createTextVNode()),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("trailhand-text-input", {
                    value: tail.value,
                    label: "Tail (number of lines)",
                    style: {"width":"100%"},
                    size: "small",
                    type: "number",
                    placeholder: "e.g., 100",
                    min: "1",
                    onTextInputChange: _cache[2] || (_cache[2] = (e) => tail.value = e.detail.value ? parseInt(e.detail.value) : null)
                  }, null, 40, _hoisted_15)
                ]),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("trailhand-text-input", {
                    value: since.value,
                    label: "Since (duration)",
                    style: {"width":"100%"},
                    size: "small",
                    type: "text",
                    placeholder: "e.g., 1h, 30m, 24h",
                    disabled: !!sinceTime.value,
                    onTextInputChange: _cache[3] || (_cache[3] = (e) => since.value = e.detail.value)
                  }, null, 40, _hoisted_17),
                  _cache[10] || (_cache[10] = _createTextVNode()),
                  _cache[11] || (_cache[11] = _createElementVNode("small", { class: "text-muted" }, "Use this OR Since Time below", -1))
                ]),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("trailhand-text-input", {
                    value: sinceTime.value,
                    label: "Since Time (absolute date)",
                    style: {"width":"100%"},
                    size: "small",
                    type: "datetime-local",
                    disabled: !!since.value,
                    onTextInputChange: _cache[4] || (_cache[4] = (e) => sinceTime.value = e.detail.value)
                  }, null, 40, _hoisted_19),
                  _cache[12] || (_cache[12] = _createTextVNode()),
                  _cache[13] || (_cache[13] = _createElementVNode("small", { class: "text-muted" }, "Use this OR Since above", -1))
                ]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", _hoisted_21, _toDisplayString(filterMode.value === 'include'
                      ? 'Selected containers will be included in logs'
                      : 'Selected containers will be excluded from logs'), 1),
                  _cache[15] || (_cache[15] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("trailhand-button", {
                      size: "small",
                      disabled: isApplyingFilters.value,
                      onClick: applyFilters
                    }, _toDisplayString(isApplyingFilters.value ? 'Applying...' : 'Apply Filters'), 9, _hoisted_23),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    _createElementVNode("trailhand-button", {
                      size: "small",
                      class: "ml-5",
                      disabled: activeFilterCount.value === 0 && !tail.value && !since.value && !sinceTime.value,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {clearContainerFilters(); clearFilters();})
                    }, "\n                      Clear\n                    ", 8, _hoisted_24)
                  ])
                ])
              ])
            ]),
            default: _withCtx(() => [
              _cache[21] || (_cache[21] = _createElementVNode("trailhand-button", {
                class: "ml-5 container-filter-btn",
                size: "small"
              }, "\n              Container Filter\n            ", -1)),
              _cache[22] || (_cache[22] = _createTextVNode())
            ]),
            _: 1,
            __: [21,22]
          }),
          _cache[24] || (_cache[24] = _createTextVNode()),
          _createElementVNode("trailhand-button", {
            class: "ml-5",
            size: "small",
            disabled: isFollowing.value,
            onClick: follow
          }, _toDisplayString(_unref(t)('wm.containerLogs.follow')), 9, _hoisted_25),
          _cache[25] || (_cache[25] = _createTextVNode()),
          _createElementVNode("trailhand-button", {
            class: "ml-5",
            size: "small",
            onClick: clear
          }, _toDisplayString(_unref(t)('wm.containerLogs.clear')), 1),
          _cache[26] || (_cache[26] = _createTextVNode()),
          _createElementVNode("trailhand-button", {
            class: "ml-5",
            size: "small",
            onClick: download
          }, _toDisplayString(_unref(t)('wm.containerLogs.download')), 1)
        ]),
        _cache[31] || (_cache[31] = _createTextVNode()),
        _cache[32] || (_cache[32] = _createElementVNode("div", { style: {"flex":"1"} }, null, -1)),
        _cache[33] || (_cache[33] = _createTextVNode()),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", {
              class: _normalizeClass({'text-success': _unref(isOpen), 'text-error': !_unref(isOpen)})
            }, _toDisplayString(_unref(t)(_unref(isOpen) ? 'wm.connection.connected' : 'wm.connection.disconnected')), 3)
          ]),
          _cache[29] || (_cache[29] = _createTextVNode()),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_VDropdown, { placement: "top-end" }, {
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("trailhand-checkbox", {
                    value: wrap.value,
                    checked: wrap.value,
                    onCheckboxChange: _cache[6] || (_cache[6] = (e) => { wrap.value = e.detail.checked; toggleWrap() })
                  }, _toDisplayString(_unref(t)('wm.containerLogs.wrap')), 41, _hoisted_30)
                ])
              ]),
              default: _withCtx(() => [
                _cache[27] || (_cache[27] = _createElementVNode("trailhand-button", { size: "small" }, [
                  _createElementVNode("i", { class: "icon icon-gear" })
                ], -1)),
                _cache[28] || (_cache[28] = _createTextVNode())
              ]),
              _: 1,
              __: [27,28]
            })
          ]),
          _cache[30] || (_cache[30] = _createTextVNode()),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("trailhand-text-input", {
              value: search.value,
              size: "small",
              type: "search",
              placeholder: _unref(t)('wm.containerLogs.search'),
              onTextInputChange: _cache[7] || (_cache[7] = (e) => search.value = e.detail.value)
            }, null, 40, _hoisted_32)
          ])
        ])
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "body",
        ref: body,
        class: _normalizeClass({'logs-container': true, 'open': _unref(isOpen), 'closed': !_unref(isOpen), 'show-times': _unref(timestamps) && filtered.value.length, 'wrap-lines': wrap.value})
      }, [
        _createElementVNode("table", _hoisted_33, [
          _createElementVNode("tbody", _hoisted_34, [
            (filtered.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(filtered.value, (line) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: line.id
                  }, [
                    _withDirectives(_createElementVNode("td", _hoisted_35, null, 512), [
                      [_directive_clean_html, format(line.time)]
                    ]),
                    _cache[34] || (_cache[34] = _createTextVNode()),
                    _withDirectives(_createElementVNode("td", _hoisted_36, null, 512), [
                      [_directive_clean_html, line.msg]
                    ])
                  ]))
                }), 128))
              : (search.value || activeFilterCount.value > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                    _createElementVNode("td", _hoisted_38, [
                      _createTextVNode(_toDisplayString(_unref(t)('wm.containerLogs.noMatch')) + " ", 1),
                      (activeFilterCount.value > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, "\n                  (" + _toDisplayString(filterMode.value === 'include' ? 'Including' : 'Excluding') + " " + _toDisplayString(activeFilterCount.value) + " container" + _toDisplayString(activeFilterCount.value !== 1 ? 's' : '') + ")\n                ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                    _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(t)('epinio.applications.wm.noData')), 1)
                  ]))
          ])
        ])
      ], 2)
    ]),
    _: 1,
    __: [35]
  }, 8, ["active"]))
}
}

})